import styled from '@emotion/styled';

export const MainBlock = styled.div`
  font-family: 'SF Pro Text', serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 100%;
  text-wrap: balance;
  color: color-mix(in srgb, ${({ theme }) => theme.colors.InkOnDark} 80%, transparent);
`;
